import { Avatar } from 'antd'
import React from 'react'

export function StatusAvatar({ severity, type, icon, size = 24 }) {
  const getBackgroundColor = () => {
    if (severity === 'error') return 'var(--theme-error)'
    if (severity === 'warning') return 'var(--theme-warning)'
    if (severity === 'money' && type !== 'dependent') return 'var(--theme-success)'
    if (severity === 'info') return 'white'

    // Type-based colors when no severity
    if (type === 'credit_hold') return 'var(--theme-error)'
    if (type === 'compliance_hold') return 'var(--theme-error)'

    return 'white'
  }

  return (
    <Avatar
      style={{
        backgroundColor: getBackgroundColor(),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '20px',
      }}
      size={type === 'run_out' && severity === 'empty' ? 28 : size}
      icon={icon}
    />
  )
}
